// client/src/dnd/emitter_tool/hooks/useAtlas.js
import { useEffect, useState } from "react";
import { loadAtlas } from "../spritesheetAtlas";

export default function useAtlas() {
  const [atlas, setAtlas] = useState(null);
  const [selectedSprite, setSelectedSprite] = useState(null);

  useEffect(() => {
    let gone = false;
    (async () => {
      const a = await loadAtlas();
      if (gone) return;

      const frameNames = Array.isArray(a?.frameNames) ? a.frameNames : [];
      const textures = a?.textures || {};

      if (frameNames.length && Object.keys(textures).length) {
        setAtlas({ textures, frameNames });
        setSelectedSprite((prev) => prev ?? frameNames[0]);
      } else {
        setAtlas({ textures: {}, frameNames: [] });
      }
    })();
    return () => { gone = true; };
  }, []);

  return { atlas, selectedSprite, setSelectedSprite };
}
